import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomConversionDataGridService } from '@piqet-angular/features';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { CustomModalService } from '@piqet-angular/shared';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { cloneDeep } from 'lodash';
import { setDelayedFlag } from 'libs/shared/src/lib/service/helper.service';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-new-custom-conversion',
  templateUrl: './new-custom-conversion.component.html',
  styleUrls: ['./new-custom-conversion.component.scss'],
})
export class NewCustomConversionComponent implements OnDestroy {
  // processId =  0;
  disableSubmit = false;
  headerBtn = 'Add row';
  conversionProcessList: any;
  customConversionForm!: FormGroup;
  conversionProcessForm: any;
  submitted = false;
  processSubmitted = false;
  isReadonly = true;
  processColumnDef: any;
  modalLabel: any;
  customData: any;
  params: any;
  setOrganizationValue: any;
  selectedDropDownValue: any;
  selectOrganization: any;
  @Output() saveCustomConversionEvent = new EventEmitter<{ payload: any; pathName: any }>();
  @Output() inlineDataEditEvent = new EventEmitter<any>();
  editDataList: any;
  conversionProcessDetail: any;

  isRowEditable = false;
  energyItems: any;
  customConversionId = 0;
  errorNotification!: string;
  activatedRoute: any;
  organizationlist: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  headerBtnName = 'customConversion';
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  fromEdit: any;
  gridLoaded = { value: false };

  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    public CustomConversionDataGridService: CustomConversionDataGridService,
    private cookieService: CookieService,
    private modal: CustomModalService,
    private swalService: SwalService,
    private sharedService: SharedService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom conversion' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminCustomConversion' ? true : false;
    this.customData = this.modal?.modalService?.config?.initialState?.['newCustomConversionData'];
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.showEdit = this.CustomConversionDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.CustomConversionDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.CustomConversionDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    this.customFacade.conversionData$.subscribe((res: any) => {
      this.customData =
        (res.hasOwnProperty('length') && res.length) || (res && res.id) || !this.fromEdit
          ? res
          : this.customData;
      this.initializeData();
    });
  }

  initializeData() {
    this.customConversionForm = this.formBuilder.group({
      conversionName: ['', [Validators.required, noWhitespaceValidator]],
      comment: [this.customData?.comment || ''],
      organizationName: [null, Validators.required],
      conversionProcessForm: this.formBuilder.group({
        process: [null, Validators.required],
        amount: [null, Validators.required],
        cost: [0, [Validators.min(0)]],
        packageCost: [0, Validators.min(0)],
      }),
    });

    this.conversionProcessForm = this.customConversionForm.controls['conversionProcessForm'];
    this.customConversionForm.patchValue({
      conversionName: this.customData.processName,
    });

    this.customFacade.energyItems$.subscribe((energyItems: any) => {
      this.processColumnDef = cloneDeep(this.processColumnDef);
      this.processColumnDef[0].cellEditorParams['conversionProcessList'] = energyItems;
    });

    this.organizationlist = this.customData?.organizationItems;
    this.customConversionId = this.customData?.id;
    this.organizatioListFunction();
    this.setFormData();
    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;
    setDelayedFlag(this.gridLoaded, true, 200);

    this.customFacade.GetCustomConversionProcessError$.subscribe((error: any) => {
      this.checkValidation(error);
    });

    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.customData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  setFormData() {
    this.customConversionForm.patchValue({ organizationName: this.selectOrganization });
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }

  checkValidation(conversionProcessError: any): void {
    this.disableSubmit = !!conversionProcessError ? true : false;
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().startsWith(term.toLowerCase());
  }
  commonInputSearchForOrganization(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  addConversionProcess() {
    this.processSubmitted = true;
    if (this.conversionProcessForm.controls['process'].valid) {
      this.conversionProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.conversionProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.conversionProcessForm.valid) {
      const processData = {
        processName: this.conversionProcessForm.value.process.description,
        amount: this.conversionProcessForm.value.amount,
        cost: this.conversionProcessForm.value.cost,
        packageCost: this.conversionProcessForm.getRawValue().packageCost,
        energyId: this.conversionProcessForm.value.process.id,
        customProcessId: this.customConversionId,
      };
      this.processSubmitted = false;
      this.customFacade.addConversionProcessActions(processData, 'add');
      this.conversionProcessForm.reset();
    }
  }

  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  onSave(conversionProcessList: any) {
    this.submitted = true;
    this.processSubmitted = false;
    if (
      this.activatedRoute == 'adminCustomConversion' &&
      !this.customConversionForm.controls['organizationName'].value?.name &&
      !this.customConversionForm.controls['organizationName'].value
    ) {
      return;
    }
    if (!conversionProcessList.length) {
      this.customFacade.setCustomConversionError('Please add atleast one conversion process.');
      this.disableSubmit = false;
      return;
    } else if (
      this.customConversionForm.errors == null &&
      this.customConversionForm.controls['conversionName'].valid
    ) {
      const saveCustomConversionData: any = {
        processName: this.customConversionForm.value.conversionName.trimStart(),
        comment: this.customConversionForm.value.comment.trimStart(),
        conversionProcessDetail: conversionProcessList,
        organizationId:
          this.customConversionForm.controls['organizationName'].value?.id ||
          this.customData.organizationId ||
          this.cookieService.get('organizationId'),
        processId: this.customConversionId,
        id: this.customConversionId,
      };
      this.saveCustomConversionEvent.emit({
        payload: saveCustomConversionData,
        pathName: this.activatedRoute,
      });
      this.submitted = false;
    }
  }

  ngOnDestroy() {
    this.customFacade.clearConversionProcess();
  }
}
